export enum ButtonLabelEnum {
  Cancel = 'Anuluj',
  CheckoutSubmit1 = 'Aktualizacja wniosku 1/3',
  CheckoutSubmit2 = 'Weryfikacja w UFG 2/3',
  CheckoutSubmit3 = 'Pobieranie cen 3/3',
  EnterNewData = 'Wprowadź nowe dane',
  FinalizePurchase = 'Dokończ zakup',
  GoToPayment = 'Wybierz sposób płatności',
  NoRegistrationNumber = 'Brak nr rej.',
  RegistrationNumber = 'Nr rej.',
  StartCalculation = 'Rozpocznij kalkulację',
  Up = 'Wróć do góry',
}
